export var Freq;
(function (Freq) {
    Freq["MON"] = "Monthly";
    Freq["QUA"] = "Quarterly";
    Freq["SEM"] = "Semi-Annual";
    Freq["ANN"] = "Annual";
})(Freq || (Freq = {}));
